import File from './File';
import Info from './Info';
import Map from './Map';

export default {
  File,
  Info,
  Map
};